<div class="simultaneous-stop-order container-fluid">
    <div class="row">
      <div class="col-12">

        <div class="form-simple-buy-order1 txt-center">
          <div class="row">
            <div class="col-2">
              <mat-form-field>
                <mat-select placeholder="conta">
                  <mat-option value="0">Informe de rendimentos</mat-option>
                  <mat-option value="1">Informe de rendimentos</mat-option>
                  <mat-option value="2">Informe de rendimentos</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-2">
                 <!-- <input type="text" matInput placeholder="ativo" disabled value="ATIVO"
                value={{currentSymbol}}
                >  -->
                 <app-auto-complete class="input-asset" (onsymbolChanged)="selectAsset($event)" [symbolAutoComplete]="currentSymbol"></app-auto-complete>

            </div>

            <div class="col-2">
              <mat-form-field>
                <!-- MISSING IN DOC -->
                <mat-select placeholder="precificação">
                  <mat-option value="0">Informe de rendimentos</mat-option>
                  <mat-option value="1">Informe de rendimentos</mat-option>
                  <mat-option value="2">Informe de rendimentos</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-2">
              <mat-form-field>
                <input type="number" matInput placeholder="quantidade" [(ngModel)]="model.quantity" [value]='model.quantity'>
              </mat-form-field>
            </div>

            <div class="col-3 size-area">
              <div class="right-side-top txt-center">
                <div>
                  <span class="default">Compra </span>
                  <span class="default-bold">{{model.quantity}} </span>
                  <span class="default">ações de </span>
                  <span class="default-bold">{{model.symbol}} </span>
                  <span class="default">à </span>
                  <span class="default-bold">{{ model.lastTrade }}</span>
                </div>
                <div>
                  <span *ngIf='!currentSymbol' class="total">
                        -
                  </span>
                  <span *ngIf='currentSymbol' class="total">
                    TOTAL - R$ {{model.valorTotal}}
                  </span>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="form-simple-buy-order2 txt-center">
          <div class="row">

            <div class="col-2">
              <mat-form-field>
                <mat-select placeholder="duração">
                   <mat-option ng-model="model.duration" *ngFor='let option of durationOptions' value="0">{{option.desc}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-2">
              <mat-form-field class="date">
                <input  ng-model="model.expiration" matInput [matDatepicker]="picker" placeholder="data do vencimento">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-2">
               <app-incremental-input name="model.gainPrice" [price]="true" [placeholder]= "'limite de ganho'" [options]="priceValuesFormatOptions" [roundLot]="1000" minValue="0"
              [isQuantity]="true" [(ngModel)]="model.gainPrice" aria-required=""></app-incremental-input>
            </div>

            <div class="col-2">
                <app-incremental-input name="model.gainTriggerPrice"  [price]="true" [placeholder]= "'disparo de ganho'" [options]="priceValuesFormatOptions" [roundLot]="1000" minValue="0"
                [isQuantity]="true" [(ngModel)]="model.gainTriggerPrice" aria-required=""></app-incremental-input>
            </div>
            <!-- <div class="col-2">
                <input  required type="number" step="0.01" matInput placeholder="Limite de ganho" [(ngModel)]="model.gainPrice">
            </div>

            <div class="col-2">
                <input  required type="number" step="0.01" matInput placeholder="Disparo de ganho" [(ngModel)]="model.gainTriggerPrice">
            </div> -->

            <div class="col-3 size-area">
              <div class="size-area-button">
                <button mat-raised-button color="buy" class="btn-buy-sell mr-1" *ngIf="flag" (click)="toggleBtn()">COMPRAR</button>
                <button mat-raised-button color="sell" class="btn-buy-sell mr-1" *ngIf="!flag" (click)="toggleBtn()">VENDER</button>
              </div>
            </div>
          </div>
        </div>

        <div class="row">

          <div class="col-2">
            <app-incremental-input name="model.lossPrice" [price]="true" [placeholder]= "'limite de perda'" [options]="priceValuesFormatOptions" [roundLot]="1000" minValue="0"
            [isQuantity]="true" [(ngModel)]="model.lossPrice" aria-required=""></app-incremental-input>
          </div>

          <div class="col-2">
              <app-incremental-input name="model.lossTriggerPrice" [price]="true" [placeholder]= "'disparo de perda'" [options]="priceValuesFormatOptions" [roundLot]="1000" minValue="0"
              [isQuantity]="true" [(ngModel)]="model.lossTriggerPrice" aria-required=""></app-incremental-input>
          </div>
          <!-- <div class="col-2">
              <input  required type="number" step="0.01" matInput placeholder="Limite de perda" [(ngModel)]="model.lossPrice">
          </div>

          <div class="col-2">
              <input  required type="number" step="0.01" matInput placeholder="Disparo de perda" [(ngModel)]="model.lossTriggerPrice">
          </div> -->

          <div class="col-2 tunnels">

            <div class="row elem">
              <div class="col-6 txt-left default-text">Tunel Máximo</div>
              <div class="col-6 txt-right default-bold">{{model.tunnelUpperLimit}}</div>
            </div>

            <div class="row elem">
              <div class="col-6 txt-left default-text">Tunel Mínimo</div>
              <div class="col-6 txt-right default-bold">{{model.tunnelLowerLimit}}</div>
            </div>
          </div>
          <div class="col-6">
            <div class="options-text">
              opções avançadas >
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
